/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100DeviceMeasurementException } from './Ptw100DeviceMeasurementException';
import {
    Ptw100DeviceMeasurementExceptionFromJSON,
    Ptw100DeviceMeasurementExceptionFromJSONTyped,
    Ptw100DeviceMeasurementExceptionToJSON,
} from './Ptw100DeviceMeasurementException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100DeviceMeasurementException
 */
export interface ErrorResponseOfPtw100DeviceMeasurementException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100DeviceMeasurementException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100DeviceMeasurementException}
     * @memberof ErrorResponseOfPtw100DeviceMeasurementException
     */
    exception: Ptw100DeviceMeasurementException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100DeviceMeasurementException
     */
    $type?: ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroApplicationSharedExceptionsPtw100DeviceMeasurementExceptionPtwPtw100AppZeroApplicationSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100DeviceMeasurementException, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum = typeof ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100DeviceMeasurementException interface.
 */
export function instanceOfErrorResponseOfPtw100DeviceMeasurementException(value?: unknown): value is ErrorResponseOfPtw100DeviceMeasurementException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100DeviceMeasurementExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSON(json: any): ErrorResponseOfPtw100DeviceMeasurementException {
    return ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100DeviceMeasurementException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100DeviceMeasurementExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100DeviceMeasurementExceptionToJSON(value?: Omit<ErrorResponseOfPtw100DeviceMeasurementException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100DeviceMeasurementExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

